export default __webpack_public_path__ + "static/media/servicio-6.7d7dae61.webp";